import { useCompleteOnboarding, useMe } from '@fidalia/api';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { DashboardPage as Dashboard } from '@/features/dashboard/dashboard-page';
import { OnboardingModal } from '@/features/onboarding/onboarding-modal';
import { track } from '@/lib/analytics';

export const Route = createFileRoute('/_app/')({
  component: DashboardPage,
});

function DashboardPage() {
  const { data: me } = useMe();
  const completeOnboarding = useCompleteOnboarding();

  // `onboardingFait` fait foi ; l'état local ne sert qu'à refermer la modale
  // sans attendre le rafraîchissement de la session.
  const [dismissed, setDismissed] = useState(false);

  // L'onboarding configure le cabinet : seul son admin peut le remplir.
  const open =
    !dismissed && me !== undefined && me.user.role === 'admin' && !me.user.onboardingFait;

  return (
    <>
      <Dashboard />

      {me ? (
        <OnboardingModal
          open={open}
          exercice={me.cabinet.exercice}
          onSubmit={async (input) => {
            const result = await completeOnboarding.mutateAsync(input);
            track('onboarding_completed');
            return result;
          }}
          onDone={() => setDismissed(true)}
        />
      ) : null}
    </>
  );
}
